import { UtilizationSetup } from "../preAnalytical";

/**
 * Masterlist of the analytical supplies (reagents, machine cartridges, etc.)
 * needed by every service, per branch.
 */
export default function AnalyticalSetup({ readOnly = false }) {
  return <UtilizationSetup phase="analytical" readOnly={readOnly} />;
}
